// Generated code for Big.Entities.AuthenticationType.
// Edit _Enum.tst to change the generated output.

export enum AuthenticationType {
    unknown = 0,
    digiD = 1,
    biglogin = 2
}
(AuthenticationType as any).name = 'AuthenticationType';
